import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app';
import './estilos.css';
import { cubrirImagenesRotas } from './imagenes-rotas';

cubrirImagenesRotas();

// Quien llega con un enlace de invitación (?ref=CÓDIGO) lo guarda hasta tener cuenta: el inicio de sesión cambia
// de página y el código se perdería. La portada lo manda al preparar la cuenta.
try {
  const ref = new URLSearchParams(location.search).get('ref');
  if (ref) localStorage.setItem('igor-ref', ref);
} catch { /* sin almacenamiento: se pierde la invitación, nada más */ }

createRoot(document.getElementById('raiz')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
